module.exports = __webpack_public_path__ + "static/media/letter_f.876c1dfb.m4a";